export default "__VITE_ASSET__ChCZFcEt__"